var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-footer footer"},[_c('div',{staticClass:"container-fluid container-p-x pb-3"},[_c('div',{staticClass:"text-right"},[_vm._v("\n      Version: "+_vm._s(this.version)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }